import React from 'react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { GetFormatForMoment } from "Core/data/Helpers";
import moment from 'moment';
import 'moment-timezone';
import { useIntl } from 'react-intl';

const detailItemSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  color: '#666',
  fontSize: '13px',
};

export const DrawerEventDetails = ({
  eventName,
  date,
  timezone,
  coordinates,
  address,
  speed,
}) => {
  const {messages} = useIntl();
  const { user } = useSelector((state) => state.securityRedux);
  const { dateformat } = user;
  const hasDetails = [date, coordinates, address, speed].some(
    (v) => v != null && v !== ''
  );

  return (
    <Box
      sx={{
        padding: '16px',
        backgroundColor: '#f5f5f5',
        borderRadius: '4px',
        marginBottom: '16px',
      }}
    >
      {eventName != null && eventName !== '' && (
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            marginBottom: '12px',
            color: '#333',
            fontSize: '16px',
          }}
        >
          {messages[eventName] ?? eventName}
        </Typography>
      )}
      {hasDetails && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          {date != null && date !== '' && (
            <Typography variant="body2" sx={detailItemSx}>
              <span style={{ fontSize: '16px' }}>🕐</span>
              {(timezone ? moment(date).tz(timezone) : moment(date)).format(`${GetFormatForMoment(dateformat)} hh:mm:ss a`)}
            </Typography>
          )}
          {coordinates != null && coordinates !== '' && (
            <Typography variant="body2" sx={detailItemSx}>
              <span style={{ fontSize: '16px' }}>📍</span>
              {coordinates}
            </Typography>
          )}
          {address != null && address !== '' && (
            <Typography variant="body2" sx={detailItemSx}>
              <span style={{ fontSize: '16px' }}>🧭</span>
              {address}
            </Typography>
          )}
          {speed != null && speed !== '' && (
            <Typography variant="body2" sx={detailItemSx}>
              <span style={{ fontSize: '16px' }}>⚡</span>
              {speed}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

